import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Works from "../pages/works/page";
import WorkDetail from "../pages/works/detail/page";
import Articles from "../pages/articles/page";
import ArticleDetail from "../pages/articles/detail/page";
import Ranking from "../pages/ranking/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "works",
        element: <Works />,
      },
      {
        path: "works/:id",
        element: <WorkDetail />,
      },
      {
        path: "articles",
        element: <Articles />,
      },
      {
        path: "articles/:id",
        element: <ArticleDetail />,
      },
      {
        path: "ranking",
        element: <Ranking />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "faq",
        element: <Faq />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;